<template>
  <div class="little-header position-relative" v-if="userInfo">
    <van-nav-bar
      @click-right="onClickRight">
      <template #left>
        <a href="/">
          <img v-if="isPc" class="h-32" src="/static/img/index/big-logo.png">
          <img v-else src="/static/img/index/logo.png">
        </a>
      </template>
      <template #right>
        <div class="font-12 d-flex justify-content-center align-items-center">
          <div v-if="isLogin" class="font-12 d-flex justify-content-center align-items-center">
            <p class="mb-0 color-66">{{userInfo.name}}</p>
            <img src="/static/img/pro/down.png" class="ml-2" alt="">
          </div>

          <div v-if="!isLogin" class="mb-0 color-base" @click="goLogin">
            登录
          </div>
        </div>
        <div v-if="isLogin" @click="logout" class="position-absolute px-4 py-1 color-66 font-12 border bg-white logout">
          退出
        </div>
      </template>
    </van-nav-bar>
  </div>
</template>

<script>
  import Cookies from 'js-cookie'
  import Vue from 'vue';
  import {NavBar, Button} from 'vant';
  Vue.use(Button)
  Vue.use(NavBar);
  export default {
    name: "littleHeader",
    data() {
      return {
        isLogin: false,
        isPc: false,
        userInfo: {},
        domain: ''
      }
    },
    mounted() {
      if (window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
        //跳转移动端页面
        this.isPc = false;
      } else {
        //跳转pc端页面
        this.isPc = true;
      }
      let names = window.location.hostname.split(".");
      if (names.length > 2) {
        names[0] = "";
      }
      this.domain = names.join(".");
      if (Cookies.get('anqiu_education_token') && Cookies.get('u_info')) {
        this.userInfo = JSON.parse(Cookies.get('u_info'));
        this.isLogin = true;
      } else {
        this.userInfo = {};
        this.isLogin = false;
        this.$store.commit('MOVE_TOKEN', {name: {key: 'u_info'}, options: {domain: this.domain}});
      }
    },
    methods: {
      onClickRight() {
        $('.logout').toggle();
      },
      goLogin() {
        if(this.isPc) {
          window.open('https://www.aqjsjx.com.cn/passport/login')
        } else {
          this.$router.push('/login');
          localStorage.setItem('current_url', location.pathname);
        }
      },
      logout() {
        this.$store.commit('MOVE_TOKEN', {name: {key: 'anqiu_education_token'}, options: {domain: this.domain}});
        this.$store.commit('MOVE_TOKEN', {name: {key: 'anqiu_education_refresh_token'}, options: {domain: this.domain}});
        this.$store.commit('MOVE_TOKEN', {name: {key: 'u_info'}, options: {domain: this.domain}});
        this.isLogin = false;
        location.reload();
      }
    }
  }
</script>

<style scoped>
 .h-32 {
   height: 32px;
 }
</style>
